import type { Collar } from "@typings/entities/devices/collar";

export interface CollarWithLabels extends Collar {
  lastLocation: string;
  ufuName: string;
}

export function prepareCollarsTable(collars: Collar[]): CollarWithLabels[] {
  return collars.map((collar) => ({
    ...collar,
    lastLocation:
      collar.lastLocationLatitude != null &&
      collar.lastLocationLongitude != null
        ? `Lat: ${collar.lastLocationLatitude}, Long: ${collar.lastLocationLongitude}`
        : "",
    ufuName: collar.individual ? collar.individual.ufuName : "",
  }));
}
